function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "wqxq1tzisa"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.486275 0 0 0 0 0.501961 0 0 0 0 0.517647 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#wqxq1tzisa)",
  transform: "translate(-932 -526) translate(443 94) translate(-4 122) translate(36 284) translate(359 17)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#B6BDC3",
  d: "M12.892 3.293c8.757 0 12.308 6.994 12.308 6.994s-3.859 7.006-12.56 7.006C3.94 17.293 0 10.287 0 10.287s4.135-6.994 12.892-6.994zM12.6 5.5c-2.74 0-4.962 2.145-4.962 4.792 0 2.646 2.222 4.792 4.962 4.792 2.74 0 4.962-2.146 4.962-4.792 0-2.647-2.222-4.792-4.962-4.792zm0 1.992c1.546 0 2.8 1.253 2.8 2.8 0 1.546-1.254 2.8-2.8 2.8-1.546 0-2.8-1.254-2.8-2.8 0-1.547 1.254-2.8 2.8-2.8z",
  transform: "translate(98 9)"
}))))))));

var SvgIconsGlobalVisibleGrayVisible = function SvgIconsGlobalVisibleGrayVisible(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconsGlobalVisibleGrayVisible, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons-global-visible-gray-visible.84c70c5b.svg";
export { ForwardRef as ReactComponent };